<app-breadcrumb  [master]="'Analizy'" [parentName]="'Umowy'" [name]="'Raporty'"></app-breadcrumb>
<div class="report-contract-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="report-contract-list-filters">
    <mat-form-field class="report-contract-list-filter">
      <mat-label>ID</mat-label>
      <input matInput placeholder="12345" name="recordId" [(ngModel)]="initialFilters.recordId">
    </mat-form-field>

    <app-dict
      [multiple]="true" [dictType]="'contract_type'"
      [label]="'Rodzaj'" class="report-contract-list-filter"
      [(ngModel)]="initialFilters.type" name="type"
    ></app-dict>

    <app-datepicker
      class="report-contract-list-filter"
      label="Data zawarcia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$concludeDate" name="gte$concludeDate"
    ></app-datepicker>

    <app-datepicker
      class="report-contract-list-filter"
      label="Data zawarcia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$concludeDate" name="lte$concludeDate"
    ></app-datepicker>

    <app-dict
      [multiple]="false" [dictType]="'company'"
      [label]="'Firma'" class="report-contract-list-filter"
      [(ngModel)]="initialFilters.company" name="company"
    ></app-dict>

    <app-dict
      [multiple]="true" [dictType]="'contract_status'"
      [label]="'Status'" class="report-contract-list-filter"
      [(ngModel)]="initialFilters.status" name="status"
    ></app-dict>

    <mat-form-field class="report-contract-list-filter">
      <mat-label>Numer</mat-label>
      <input matInput placeholder="12345" name="contains$number" [(ngModel)]="initialFilters.contains$number">
    </mat-form-field>

    <app-datepicker
      class="report-contract-list-filter"
      label="Aktywna od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$activeFrom" name="gte$activeFrom"
    ></app-datepicker>

    <app-datepicker
      class="report-contract-list-filter"
      label="Aktywna do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$activeFrom" name="lte$activeFrom"
    ></app-datepicker>

    <app-datepicker
      class="report-contract-list-filter"
      label="Data zakończenia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$activeTo" name="gte$activeTo"
    ></app-datepicker>

    <app-datepicker
      class="report-contract-list-filter"
      label="Data zakończenia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$activeTo" name="lte$activeTo"
    ></app-datepicker>

    <app-dict
      [multiple]="false" [dictType]="'termination_time'"
      [label]="'Okres wypowiedzenia'" class="report-contract-list-filter"
      [(ngModel)]="initialFilters.terminationTime" name="terminationTime"
    ></app-dict>

    <app-dict
      [multiple]="false" [dictType]="'termination_type'"
      [label]="'Sposób rozwiązania'" class="report-contract-list-filter"
      [(ngModel)]="initialFilters.terminationType" name="terminationType"
    ></app-dict>

    <app-dict
      [multiple]="false" [dictType]="'contract_period'"
      [label]="'Czas trwania'" class="report-contract-list-filter"
      [(ngModel)]="initialFilters.period" name="period"
    ></app-dict>

    <app-dict
      [multiple]="false" [dictType]="'contract_owner'"
      [label]="'Strona umowy'" class="report-contract-list-filter"
      [(ngModel)]="initialFilters.owner" name="owner"
    ></app-dict>

    <app-dict-partners
      [multiple]="false" [label]="'Partner'"
      class="report-contract-list-filter report-contract-list-filter-long"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

    <app-dict-ofwcas
      [multiple]="false" label="OFWCA"
      class="report-contract-list-filter report-contract-list-filter-long"
      [(ngModel)]="initialFilters.ofwca" name="ofwca"
    ></app-dict-ofwcas>

    <app-dict-regionals
      [multiple]="false" [label]="'Regionalny (majątek)'"
      class="report-contract-list-filter"
      [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
    ></app-dict-regionals>

    <mat-form-field appearance="standard" class="report-contract-list-filter">
      <mat-label>Rekord zweryfikowany</mat-label>
      <mat-select [(ngModel)]="initialFilters.verified" name="verified">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="standard" class="report-contract-list-filter">
      <mat-label>Aktualne zgłoszenie</mat-label>
      <mat-select [(ngModel)]="initialFilters.signedCurrentApplications" name="signedCurrentApplications">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>
  </form>

  <div class="report-contract-list-buttons">
    <button *ngIf="(userPermissions | async).analysis.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).analysis.read_report"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>


</div>
